'use client'

import { useKitchenSyncStatus } from '@/shared/sync/useKitchenSyncStatus'
import { OfflineBanner } from '@/shared/components/OfflineBanner'
import { delmanTerms } from '@/features/delman/delmanTerms'

export function DelmanOfflineBanner() {
  const { online, pendingCount } = useKitchenSyncStatus()

  return (
    <OfflineBanner
      visible={!online || pendingCount > 0}
      offlineMessage={
        !online ? delmanTerms.sync.offlineBanner : delmanTerms.sync.pending(pendingCount)
      }
      offlineDetail={
        !online ? delmanTerms.sync.offlineBannerDetail : delmanTerms.sync.tapToRetry
      }
      pendingMessage={
        !online && pendingCount > 0
          ? delmanTerms.sync.offlinePending(pendingCount)
          : undefined
      }
    />
  )
}
